import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import Breadcrumb from "../components/breadCrumb";

import { PhrasesContext } from "../context/phrasesContext";
import ThemeLayout from "../layouts/ThemeLayout";
import { getPendingPaymentServicesWithRequests } from "../services/Common";

import InvoicesWithRequstsSection from "../components/InvoicesWithRequstsSection";
import InvoicesPaymentSection from "../components/InvoicesPaymentSection";
import { Disclosure, Transition } from "@headlessui/react";
import CaseDetailsSectionLatestMobile from "../components/case-tracking/CaseDetailsSectionLatestMobile";

const InvoiceDetails = () => {
  const { caseid } = useParams();

  const [lang, setLang] = useState("");
  const [loading, setLoading] = useState(true);
  const [enPhrase, arPhrase] = useContext(PhrasesContext);
  const [service, setService] = useState({});
  const [isInvoiceDetails, setIsInvoiceDetails] = useState();
  // Track selections by unique generated keys (e.g., "caseNumber" or index fallback)
  const [selectedRequests, setSelectedRequests] = useState([]);

  useEffect(() => {
    const lang = window.localStorage.getItem("lang");
    let currentLang = lang;
    if (lang === "en") {
      document.body.dir = "ltr";
      setLang("en");
      currentLang = "en";
    } else {
      document.body.dir = "rtl";
      setLang("ar");
      currentLang = "ar";
    }
    getServiceDetailsService(currentLang);
  }, []);

  const getServiceDetailsService = (currentLang) => {
    return getPendingPaymentServicesWithRequests(caseid, currentLang).then(
      (res) => {
        console.log("rxxxxes", res?.isSuccess);
        setIsInvoiceDetails(res?.isSuccess);
        setService(res);
        setLoading(false);
      },
    );
  };

  const requestsList = service?.data?.services || [];

  // Helper to generate a truly unique identifier for each item
  const getRequestUniqueKey = (req, index) => {
    return req?.caseNumber
      ? `${req.caseNumber}-${index}`
      : `req-index-${index}`;
  };

  // Toggle Single Request Selection
  const handleToggleRequest = (uniqueKey) => {
    setSelectedRequests((prev) =>
      prev.includes(uniqueKey)
        ? prev.filter((key) => key !== uniqueKey)
        : [...prev, uniqueKey],
    );
  };

  // Select All / Deselect All Trigger
  const handleToggleSelectAll = () => {
    if (selectedRequests.length === requestsList.length) {
      setSelectedRequests([]); // Clear all
    } else {
      const allUniqueKeys = requestsList.map((req, idx) =>
        getRequestUniqueKey(req, idx),
      );
      setSelectedRequests(allUniqueKeys); // Fill all
    }
  };

  console.log("requestsList", service?.data?.case);
  console.log("serviceserviceservice", service?.isSuccess);
  console.log("isInvoiceDetails", isInvoiceDetails);

  return (
    <ThemeLayout>
      {loading ? (
        <p className="text-[#b68a35] font-bold font-Almarai mt-[8px]">
          {lang === "en" ? "Loading..." : "جاري عرض البيانات..."}
        </p>
      ) : (
        <div className="flex flex-col w-full py-4 max-w-[1440px] px-[16px] md:px-[24px] lg:px-[0px]">
          <Breadcrumb
            title={
              lang === "en" ? enPhrase["lblMycases"] : arPhrase["lblMycases"]
            }
            subtitle1Href={"9999"}
            last={
              lang === "en" ? enPhrase["lblInvoices"] : arPhrase["lblInvoices"]
            }
            lastHref={"/invoices"}
            lastSecond={caseid}
          />

          <div className="flex flex-col md:flex-row items-start md:items-center justify-between mb-[16px] md:mb-[24px]">
            <div className="flex flex-col items-start gap-[8px]">
              <div className="flex flex-row items-center gap-[8px]">
                <h1 className="text-[18px] md:text-[20px] text-[#010202] font- font-Almarai leading-[22px]">
                  {lang === "en"
                    ? enPhrase["lblOrderDues"]
                    : arPhrase["lblOrderDues"]}
                </h1>
                <p className="text-[20px] text-[#010202] font- font-Almarai leading-[22px]">
                  {caseid}
                </p>
              </div>
              <p className="text-[12px] text-[#8D867D] font-Almarai  font- leading-[24px]">
                {lang === "en"
                  ? enPhrase["lblOrderDuesText"]
                  : arPhrase["lblOrderDuesText"]}
              </p>
            </div>

            <div className="flex flex-row items-center border border-[#3E3B37] bg-[#3E3B37] py-[2px] px-[10px] rounded-[40px] gap-[4px] my-[8px] md:my-0">
              <img src="/assets/img/invoices/FileText.svg" alt="" />
              <div className="flex flex-row items-center gap-[4px]">
                <span className="text-[12px] text-[#fff] font-Almarai  font-normal">
                  {requestsList.length}
                </span>
                <p className="text-[12px] text-[#fff] font-Almarai font-normal">
                  {lang === "en"
                    ? enPhrase["lblRequests"]
                    : arPhrase["lblRequests"]}
                </p>
              </div>
            </div>
          </div>

          <Disclosure
            as="div"
            className="w-full bg-[#F3F0EA] border-[0.5px] border-[#E6D7A2] shadow-[0px_10px_40px_#361E1214] rounded-[8px] flex md:hidden flex-col items-center gap-[24px] mb-[12px] md:mb-0"
            defaultOpen={false}
          >
            {({ open }) => (
              <div className="w-full">
                <Disclosure.Button className="group flex w-full items-center justify-between px-[16px] h-[56px]">
                  <p className="font-Almarai font-bold text-[14px] leading-[20px] text-[#361E12]">
                    {lang === "en"
                      ? enPhrase["lblCaseDetails"]
                      : arPhrase["lblCaseDetails"]}
                  </p>

                  <div className="flex items-center justify-center gap-2">
                    <img
                      src="/assets/img/add-request/dash.svg"
                      alt="dash"
                      className="w-[1px] h-[20px]"
                    />
                    <img
                      className={`size-5 transition-transform duration-500 ease-in-out ${open ? "rotate-0" : "rotate-180"}`}
                      src="/assets/img/add-request/ArrowUP.svg"
                      alt="arrow"
                    />
                  </div>
                </Disclosure.Button>

                <Transition
                  show={open}
                  enter="transition-all duration-700 ease-in-out"
                  enterFrom="max-h-0 opacity-0"
                  enterTo="opacity-100"
                  leave="transition-all duration-500 ease-in-out"
                  leaveFrom="opacity-100"
                  leaveTo="max-h-0 opacity-0"
                  className="overflow-hidden flex items-center justify-center"
                >
                  <Disclosure.Panel
                    static
                    className={`${typeof window !== "undefined" && window.innerWidth <= 768 ? "mx-[4px] mb-[4px]" : "mx-[8px] mb-[8px]"} w-[99%] rounded-[12px] border-[0.5px] border-solid border-[#D4D2CE] bg-[#fff] shadow-[0px_10px_40px_#351F131F] p-[16px] gap-[16px] flex flex-col transition-all duration-500 ease-in-out overflow-visible`}
                  >
                    <CaseDetailsSectionLatestMobile
                      service={service?.data?.case}
                      lang={lang}
                      arPhrase={arPhrase}
                      enPhrase={enPhrase}
                      IsInvoice
                    />
                  </Disclosure.Panel>
                </Transition>
              </div>
            )}
          </Disclosure>

          <div className="flex flex-col md:flex-row items-start justify-between gap-[16px] md:gap-0">
            <div className="flex flex-col gap-[12px] md:gap-[32px] w-full md:w-[65%]">
              <div className="flex flex-row items-center justify-between py-[4px] px-[16px] rounded-[8px] border !border-[#F9F7ED] bg-[#F3F0EA]">
                <p className="font-Almarai font- text-[12px]  leading-[24px]  text-[#6F6A62] flex flex-row items-center gap-[4px]">
                  <p>
                    {lang === "en"
                      ? enPhrase["lblActiveSelect"]
                      : arPhrase["lblActiveSelect"]}
                  </p>
                  <p>{selectedRequests.length}</p>
                  <p>
                    {lang === "en"
                      ? enPhrase["lblActiveSelectText"]
                      : arPhrase["lblActiveSelectText"]}
                  </p>
                  <p>{requestsList.length}</p>
                </p>
                <p
                  onClick={handleToggleSelectAll}
                  className="font-Almarai font- text-[12px]  leading-[24px]  text-[#B68A35] cursor-pointer select-none"
                >
                  {selectedRequests.length === requestsList.length
                    ? lang === "en"
                      ? enPhrase["lblUnSelectAll"]
                      : arPhrase["lblUnSelectAll"]
                    : lang === "en"
                      ? enPhrase["lblSelectAll"]
                      : arPhrase["lblSelectAll"]}
                </p>
              </div>

              <InvoicesWithRequstsSection
                enPhrase={enPhrase}
                arPhrase={arPhrase}
                lang={lang}
                requests={requestsList}
                selectedRequests={selectedRequests}
                onToggleRequest={handleToggleRequest}
                getRequestUniqueKey={getRequestUniqueKey}
              />
            </div>

            <InvoicesPaymentSection
              service={service}
              enPhrase={enPhrase}
              arPhrase={arPhrase}
              lang={lang}
              requests={service?.data}
              selectedCount={selectedRequests.length}
              servicesList={requestsList} // Pass the full services array here
              selectedRequests={selectedRequests} // Pass the tracking state array here
              getRequestUniqueKey={getRequestUniqueKey} // Pass down the key matching function
              caseid={caseid}
            />
          </div>
        </div>
      )}
    </ThemeLayout>
  );
};

export default InvoiceDetails;
